import { Component, ViewChild, ElementRef } from '@angular/core';
import { AuthService, AuthState, LoginWithToken } from '@frontend/auth-store';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent {
  @ViewChild('input1') input1!: ElementRef;
  @ViewChild('input2') input2!: ElementRef;
  @ViewChild('input3') input3!: ElementRef;
  @ViewChild('input4') input4!: ElementRef;
  @ViewChild('input5') input5!: ElementRef;
  @ViewChild('input6') input6!: ElementRef;

  email = '';
  accountName = 'John Doe';
  accountUsername = '/doe';
  userId = '';
  reason = '';

  code1 = '';
  code2 = '';
  code3 = '';
  code4 = '';
  code5 = '';
  code6 = '';

  showReasonCard = false;
  showVerificationCard = false;
  showSuccessCard = false;
  showFindAccount = true;
  isLoading = false;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private authStore: Store<AuthState>,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activeRoute.queryParams.subscribe((query: any) => {
      if (query && query.token) {
        this.authStore.dispatch(LoginWithToken({ token: query.token }));
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) {
          this.authStore.dispatch(LoginWithToken({ token }));
        }
      }
    });
  }

  findAccount(): void {
    if (!this.email) {
      this.toastr.error('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email)) {
      this.toastr.error('Please enter a valid email address');
      return;
    }

    this.isLoading = true;

    this.authService.verifyEmail(this.email).subscribe({
      next: (response: any) => {
        if (response.success && response.data) {
          this.isLoading = false;
          this.showFindAccount = false;
          this.showVerificationCard = false;
          this.showSuccessCard = false;
          this.accountName = response.data.display_name;
          this.accountUsername = response.data.user_name;
          this.userId = response.data._id;
          this.showReasonCard = true;
          this.toastr.success('Account found successfully');
        } else {
          this.toastr.error(response.message || 'Account not found');
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.toastr.error(error.message || 'Failed to verify email. Please try again.');
      }
    });
  }

  sendVerification(): void {
    if (this.reason) {
      this.authService.sendDeleteOtp(this.email, this.reason).subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            this.isLoading = false;
            this.showFindAccount = false;
            this.showReasonCard = false;
            this.showSuccessCard = false;
            this.showVerificationCard = true;
            this.toastr.success('OTP sent to your registered email for verification.');
          } else {
            this.toastr.error(response.message || 'Something went wrong. Please try again.');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toastr.error(error.message || 'Failed to verify email. Please try again.');
        }
      });
    } else {
      this.toastr.error('Please enter a reason for deleting your account.');
    }
  }

  moveToNext(event: any, position: number): void {
    const input = event.target;
    if (input.value.length === 1) {
      switch (position) {
        case 1:
          this.input2.nativeElement.focus();
          break;
        case 2:
          this.input3.nativeElement.focus();
          break;
        case 3:
          this.input4.nativeElement.focus();
          break;
        case 4:
          this.input5.nativeElement.focus();
          break;
        case 5:
          this.input6.nativeElement.focus();
          break;
      }
    }
  }

  confirm(): void {
    const code = this.code1 + this.code2 + this.code3 + this.code4 + this.code5 + this.code6;
    if (code.length === 6) {
      this.authService.verifyDeleteOTP(this.email, code, this.reason).subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            this.isLoading = false;
            this.showFindAccount = false;
            this.showReasonCard = false;
            this.showVerificationCard = false;
            this.toastr.success(response.message || 'Account deleted successfully.');
            setTimeout(() => {
              this.router.navigate(['/']);
            }, 1500);
          } else {
            this.toastr.error(response.message || 'Something went wrong. Please try again.');
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.toastr.error(error.message || 'Failed to verify email. Please try again.');
        }
      });
    } else {
      this.toastr.error('Please enter the 6-digit code sent to your email.');
    }
  }

}
